import {
  ANI_ROUTER,
  CLIENT,
  DATE_RANGE_ROUTER,
  DAY_OF_WEEK_ROUTER,
  DNIS_ROUTER,
  HUNT_GROUP,
  IP_AUTHENTICATION,
  MATCH_START,
  NUMBER_PLAN,
  PLAY,
  PLUGIN,
  QUEUE,
  REMOTE,
  ROUTE_START,
  SAY,
  SCRIPT,
  SIP,
  SIP_GATEWAY,
  TEAM,
  TIME_RANGE_ROUTER,
  VOICEMAIL,
  ZONE_ROUTER,
} from "callable-data-objects";
import DeviceTypes from "Components/Device/DeviceTypes";
import CreateInboundFlowForm from "Components/Device/InboundFlow/CreateInboundFlowForm";
import CreateOutboundFlowForm from "Components/Device/OutboundFlow/CreateOutboundFlowForm";
import PlayCreate from "Components/Device/Play/PlayCreate";
import CreatePluginForm from "Components/Device/Plugin/CreatePluginForm";
import CreateSayForm from "Components/Device/Say/SayCreate";
import CreateScriptForm from "Components/Device/Script/CreateScriptForm";
import TrunkForm from "Components/Device/Trunk/TrunkCreateForm";
import SimpleBreadcrumbs from "Components/Shared/SimpleBreadcrumbs";
import { useDevice } from "Hooks/Endpoints";
import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import AniRouterCreate from "./AniRouter/AniRouterCreate";
import ClientCreate from "./Client/ClientCreate";
import DateRangeRouterCreate from "./DateRange/DateRangeRouterCreate";
import DayOfWeekRouterCreate from "./DayOfWeek/DayOfWeekRouterCreate";
import DigitsCreate from "./Digits/DigitsCreate";
import DnisRouterCreate from "./DnisRouter/DnisRouterCreate";
import HuntGroupCreate from "./HuntGroup/HuntGroupCreate";
import CreateQueueForm from "./Queue/CreateQueueForm";
import RegionRouterCreate from "./RegionRouter/RegionRouterCreate";
import RemoteCreate from "./Remote/RemoteCreate";
import SipExtensionCreate from "./SipExtension/SipExtensionCreate";
import SipGatewayCreate from "./SipGateway/SipGatewayCreate";
import TeamsCreate from "./Teams/TeamsCreate";
import TimeRangeRouterCreate from "./TimeRange/TimeRangeRouterCreate";
import VoicemailCreate from "./Voicemail/VoicemailCreate";

const CreateDeviceSelect: FunctionComponent = () => {
  const { createDevice, uncreate } = useDevice();
  const [deviceType, setDeviceType] = useState<string | undefined>(
    createDevice?.deviceType
  );
  const [step, setStep] = useState<string>("start");

  const select = (type: string) => {
    setDeviceType(type);
    setStep("build");
  };

  useEffect(() => {
    if (deviceType && createDevice?.deviceType && createDevice?.noStep) {
      select(createDevice.deviceType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceType]);

  return (
    <Fragment>
      <SimpleBreadcrumbs title='Devices' subtitle='Create' onBack={uncreate} />
      {step === "start" && (
        <DeviceTypes select={select} createDevice={createDevice} />
      )}
      {step === "build" && deviceType === IP_AUTHENTICATION && <TrunkForm />}
      {step === "build" && deviceType === SAY && <CreateSayForm />}
      {step === "build" && deviceType === PLAY && <PlayCreate />}
      {step === "build" && deviceType === REMOTE && <RemoteCreate />}
      {step === "build" && deviceType === SCRIPT && <CreateScriptForm />}
      {step === "build" && deviceType === PLUGIN && <CreatePluginForm />}
      {step === "build" && deviceType === QUEUE && <CreateQueueForm />}
      {step === "build" && deviceType === CLIENT && <ClientCreate />}
      {step === "build" && deviceType === SIP && <SipExtensionCreate />}
      {step === "build" && deviceType === SIP_GATEWAY && <SipGatewayCreate />}
      {step === "build" && deviceType === TEAM && <TeamsCreate />}
      {step === "build" && deviceType === HUNT_GROUP && <HuntGroupCreate />}

      {step === "build" && deviceType === ANI_ROUTER && <AniRouterCreate />}
      {step === "build" && deviceType === DNIS_ROUTER && <DnisRouterCreate />}
      {step === "build" && deviceType === NUMBER_PLAN && <DigitsCreate />}
      {step === "build" && deviceType === ZONE_ROUTER && <RegionRouterCreate />}
      {step === "build" && deviceType === TIME_RANGE_ROUTER && (
        <TimeRangeRouterCreate />
      )}
      {step === "build" && deviceType === DATE_RANGE_ROUTER && (
        <DateRangeRouterCreate />
      )}
      {step === "build" && deviceType === DAY_OF_WEEK_ROUTER && (
        <DayOfWeekRouterCreate />
      )}

      {step === "build" && deviceType === ROUTE_START && (
        <CreateInboundFlowForm />
      )}
      {step === "build" && deviceType === MATCH_START && (
        <CreateOutboundFlowForm />
      )}
      {step === "build" && deviceType === VOICEMAIL && <VoicemailCreate />}
    </Fragment>
  );
};

export default CreateDeviceSelect;
